import { render, staticRenderFns } from "./dates-toggle.vue?vue&type=template&id=519a9a6c"
import script from "./dates-toggle.vue?vue&type=script&lang=js"
export * from "./dates-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports